import { render, staticRenderFns } from "./TechnicalFeaturesFloor.vue?vue&type=template&id=412e80f2"
import script from "./TechnicalFeaturesFloor.vue?vue&type=script&lang=js"
export * from "./TechnicalFeaturesFloor.vue?vue&type=script&lang=js"
import style0 from "./TechnicalFeaturesFloor.vue?vue&type=style&index=0&id=412e80f2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports